ixModuleRouting("impactx.beco", {
    "/becoorder": {
        template: '<ixa-beco-cancel-vcharge-list></ixa-beco-cancel-vcharge-list>',
        templateUrl: "modules/beco/templates/becoorder.html",
        process: "Beco",
        controller: "BecoOrderListCtrl",
        controllerAs: "becoOrderListCtrl",
        workspace: "monitor",
    },
    "/becoordervcharge": {
        template: '<ixa-order-vcharge-list></ixa-order-vcharge-list>',
        templateUrl: "modules/beco/templates/becoordervcharge.html",
        process: "Beco",
        controller: "BecoOrderVChargeListCtrl",
        controllerAs: "becoOrderVChargeListCtrl",
        workspace: "monitor",
    },
    "/becocancel": {
        template: '<ixa-beco-cancel-list></ixa-beco-cancel-list>',
        templateUrl: "modules/beco/templates/becocancel.html",
        process: "Beco",
        controller: "BecoCancelListCtrl",
        controllerAs: "becoCancelListCtrl",
        workspace: "monitor",
    },
    "/becocancelvcharge": {
        template: '<ixa-beco-cancel-vcharge-list></ixa-beco-cancel-vcharge-list>',
        templateUrl: "modules/beco/templates/becocancelvcharge.html",
        process: "Beco",
        controller: "BecoCancelVChargeListCtrl",
        controllerAs: "becoCancelVChargeListCtrl",
        workspace: "monitor",
    },
});
